(function () {
  var $ = function (id) { return document.getElementById(id); };
  var money = function (cents) { return "$" + (cents / 100).toFixed(2); };
  var FREE_SHIP = 7500;

  /* ---------- cart drawer ---------- */
  function openDrawer() { $("drawer").hidden = false; $("scrim").hidden = false; refreshCart(); }
  function closeDrawer() { $("drawer").hidden = true; $("scrim").hidden = true; }

  $("cartBtn") && $("cartBtn").addEventListener("click", openDrawer);
  $("drawerClose") && $("drawerClose").addEventListener("click", closeDrawer);
  $("scrim") && $("scrim").addEventListener("click", closeDrawer);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

  function refreshCart() {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(renderCart);
  }

  function renderCart(cart) {
    var count = $("cartCount");
    if (count) { count.textContent = cart.item_count; count.hidden = cart.item_count === 0; }
    var box = $("dItems");
    if (box) {
      box.innerHTML = "";
      if (!cart.items.length) box.innerHTML = '<div class="dEmpty">Cart&rsquo;s empty. Fix that.</div>';
      cart.items.forEach(function (it) {
        var d = document.createElement("div");
        d.className = "dItem";
        d.innerHTML = '<img alt=""><div class="di"><div class="n"></div><div class="o"></div><div class="p"></div><div class="qty"><button class="dec">&minus;</button><span class="q"></span><button class="inc">+</button><button class="rm">remove</button></div></div>';
        if (it.image) d.querySelector("img").src = it.image.replace(/(\.[a-z]+)(\?|$)/, "_160x$1$2");
        d.querySelector(".n").textContent = it.product_title;
        d.querySelector(".o").textContent = it.variant_title === "Default Title" ? "" : (it.variant_title || "");
        d.querySelector(".p").textContent = money(it.final_price);
        d.querySelector(".q").textContent = it.quantity;
        d.querySelector(".inc").addEventListener("click", function () { changeQty(it.key, it.quantity + 1); });
        d.querySelector(".dec").addEventListener("click", function () { changeQty(it.key, it.quantity - 1); });
        d.querySelector(".rm").addEventListener("click", function () { changeQty(it.key, 0); });
        box.appendChild(d);
      });
    }
    $("dTotal") && ($("dTotal").textContent = money(cart.total_price));
    var pct = Math.min(100, cart.total_price / FREE_SHIP * 100);
    $("shipFill") && ($("shipFill").style.width = pct + "%");
    $("shipMsg") && ($("shipMsg").innerHTML = cart.total_price >= FREE_SHIP
      ? "<b>FREE shipping unlocked</b> &#128184;"
      : "Add <b>" + money(FREE_SHIP - cart.total_price) + "</b> more for <b>FREE shipping</b>");
  }

  function changeQty(key, qty) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  refreshCart();

  /* ---------- scroll reveal (desktop only — phones get instant content) ---------- */
  if (window.innerWidth >= 700 && "IntersectionObserver" in window && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    var targets = document.querySelectorAll(".card, .tile, .secHead, .bandIn > *, .newsIn > *, .usp");
    targets.forEach(function (el, i) {
      el.classList.add("rv");
      el.style.transitionDelay = (i % 4) * 60 + "ms";
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: "0px 0px -40px 0px" });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* ---------- product page ---------- */
  var P = window.BZ_PRODUCT;
  if (P) {
    var sel = {};
    var currentVariant = function () {
      return (P.variants || []).find(function (v) {
        return (v.options || []).every(function (val, i) { return sel[i] === undefined || val === sel[i]; });
      });
    };
    var syncVariant = function () {
      var v = currentVariant(), add = $("addBtn");
      if (v) {
        $("variantId").value = v.id;
        $("pPrice") && ($("pPrice").textContent = money(v.price));
        if (add) { add.disabled = !v.available; add.textContent = v.available ? "Add to cart" : "Sold out"; }
        if (v.featured_image && $("pMainImg")) $("pMainImg").src = v.featured_image.src;
      } else if (add) { add.disabled = true; add.textContent = "Unavailable"; }
    };
    (P.options || []).forEach(function (name, i) {
      var row = document.querySelector('[data-option-index="' + i + '"]');
      if (!row) return;
      var first = row.querySelector(".optBtn.sel") || row.querySelector(".optBtn");
      if (first) { first.classList.add("sel"); sel[i] = first.dataset.value; }
      row.querySelectorAll(".optBtn").forEach(function (b) {
        b.addEventListener("click", function () {
          row.querySelectorAll(".optBtn").forEach(function (x) { x.classList.remove("sel"); });
          b.classList.add("sel");
          sel[i] = b.dataset.value;
          syncVariant();
        });
      });
    });
    syncVariant();
    $("addBtn") && $("addBtn").addEventListener("click", function () {
      var v = currentVariant();
      if (!v) return;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: v.id, quantity: 1 })
      }).then(function () { openDrawer(); });
    });
    document.querySelectorAll(".pThumb").forEach(function (t) {
      t.addEventListener("click", function () {
        document.querySelectorAll(".pThumb").forEach(function (x) { x.classList.remove("sel"); });
        t.classList.add("sel");
        $("pMainImg").src = t.dataset.src;
      });
    });
  }
})();
